import { render } from "./loadingComponent.vue?vue&type=template&id=3285ba80&scoped=true"
import script from "./loadingComponent.vue?vue&type=script&lang=js"
export * from "./loadingComponent.vue?vue&type=script&lang=js"

import "./loadingComponent.vue?vue&type=style&index=0&id=3285ba80&scoped=true&lang=css"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3285ba80"]])

export default __exports__